export const VIEW_TYPE = {
  MONTH: 'month',
  DAY: 'day',
  WEEK: 'week',
} as const
